import {THREE_DAYS_IN_SECONDS, THOUSAND, ZERO} from "../constants";
import axios from "../../axios-instance";
import {createFormData} from '../helpers/form-data-helper';

const startReminder = (reminderData) => {
  return new Promise((resolve, reject) => {
    let timestamp = Math.floor(Date.now() / THOUSAND);
    if ((timestamp - reminderData.showTime) > THREE_DAYS_IN_SECONDS && reminderData.active) {
      resolve(reminderData);
    } else {
      reject();
    }
  });
};

const renderHTML = data => {
  return axios
    .get('/reminder/get_reminder_template')
    .then(response => {
      if (response.data.template) {
        let layout = document.createElement('div');
        layout.className = 'modal-layout js-modal-mfa-box';
        let box = document.createElement('div');
        box.className = 'js-modal-mfa-box';
        box.innerHTML = response.data.template;
        document.body.append(layout);
        document.body.append(box);
        if (popupNotifications.length > ZERO) {
          box.style.display = 'none';
          layout.style.display = 'none';
        }
        return data;
      }
    })
    .catch(() => {});
};

const bindPopupEvents = reminderData => {
  reminderData.showTime = Math.floor(Date.now() / THOUSAND);
  // close modal event
  const closeButtons = document.querySelectorAll('.js-modal-close-btn');
  let updateReminderExpBtnType = 'remind';
  for (let btn of closeButtons) {
    btn.addEventListener('click', () => {
      destroyModalBox();
      if (btn.getAttribute('data-type') === updateReminderExpBtnType) {
        updateReminder(reminderData);
      }
    });
  }
  // submit modal btn, destroy modal and open my account
  const submitButton = document.querySelector('.js-modal-action-btn');
  submitButton.addEventListener('click', () => {
    destroyModalBox();
    _edit_my_account();
  });
};

const updateReminder = reminderData => {
  axios
    .post('/reminder/update_reminder', createFormData({'reminder': JSON.stringify(reminderData)}))
    .catch(() => {});
};

const destroyModalBox = () => {
  const modalParts = document.querySelectorAll('.js-modal-mfa-box');
  for(let el of modalParts) {
    el.remove();
  }
};

export default {startReminder, renderHTML, bindPopupEvents};
